import React from "react";
import PrivacyPolicy from "../components/PrivacyPolicy";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const PrivacyPolicyPage = () => {
  return (
    <>
      <BreadcrumbTwo title="Privacy Policy" />
      <PrivacyPolicy />
    </>
  );
};

export default PrivacyPolicyPage;